/* eslint-disable import/no-namespace */
import axios from 'axios'
import { URL } from '../../config'
import { getRequest, postRequest } from '../../utils/httpRequest'
import * as types from './'

// define URLS
const centerURL = URL.center
const memberURL = URL.member
const  eventURL = URL.event
const seasonURL = URL.season
const postEventURL = URL.postevent

export function resetEventWizard()
{
	return {
		type: types.RESET_EVENT_WIZARD
	}
}
export function fetchingEvent()
{
	return {
		type: types.FETCHING_EVENT
	}
}
export function fetchEvent(eventId){
	const url = `${eventURL}/${eventId}`
	const request = getRequest(url)
	return {
		type: types.FETCH_EVENT,
		payload: request
	}
}
export function fetchNonMemberSchools(schoolName){
	const url = `${seasonURL}/nonmembers/${schoolName}`
	const request = getRequest(url)
	return {
		type:types.FETCH_NONMEMBER_SCHOOLS,
		payload:request
	}
}
export function fetchActiveSeasons(){
	const url = `${seasonURL}/active`
	const request = getRequest(url)
	return {
		type: types.FETCH_ACTIVE_SEASONS,
		payload: request
	}
}
export function fetchAllSeasons(){
  const url = `${seasonURL}/all`
  const request = getRequest(url)
  return {
    type: types.FETCH_ALL_SEASONS,
    payload: request
  }
}
export function setCorrectEventInfo(eventId,isValid,details)
{
	const url = `${eventURL}/${eventId}/verifyinfo/${isValid}/${details}`
	const request = postRequest(url)
	return {
		type: types.SET_CORRECT_EVENT_INFO,
		payload: request
	}
}
export function setHasBrackets(hasBrackets)
{
	return {
		type: types.SET_HAS_BRACKETS,
		payload: hasBrackets
	}
}
export function setCorrectEventDetails(eventId,isValid,details)
{
	const url = `${eventURL}/${eventId}/verifydetails/${isValid}/${details}`
	const request = postRequest(url)
	return {
		type: types.SET_CORRECT_EVENT_DETAILS,
		payload: request
	}
}
export function setJVEvent(hasJV)
{
	const request = {
		hasJV
	}
	return {
		type: types.SET_EVENT_JV,
		payload: request
	}
}
export function updateJVEvent(eventId, hasMen, hasWomen)
{
	const url = `${eventURL}/${eventId}/jv/${hasMen}/${hasWomen}`
	const request = postRequest(url)
	return {
		type: types.UPDATE_EVENT_JV,
		payload: request
	}
}
export function fetchCenter(searchby, searchvalue){
	let url = ''
	switch(searchby) {
		case types.SEARCH_BY_NAME:{
			url = `${centerURL}?name=${searchvalue}&size=50`
			break
		}
		case types.SEARCH_BY_NUMBER: {
			url = `${centerURL}/cert?number=${searchvalue}&size=50`
			break
		}
	}
	const request = getRequest(url)
	return {
		type: types.FETCH_CENTER,
		payload: request
	}
}
export function fetchMember(prefix,suffix,userToken) {

//const url = `${memberURL}?prefix=${prefix}&suffix=${suffix}`
const url = `${memberURL}/${prefix}/${suffix}`
const request = getRequest(url,'json',userToken)
	return {
		type: types.FETCH_MEMBER,
		payload: request
	}
}
export function fetchNonMemberSchool(schoolId) {
	const url = `${seasonURL}/nonmember/${schoolId}`
	const request = getRequest(url)
	return {
		type: types.FETCH_NONMEMBER_SCHOOL_DETAILS,
		payload: request
	}
}
export function setEventSponsor(sponsor) {
    return {
		type: types.SET_EVENT_SPONSOR,
		payload:sponsor
	}
}
export function saveEventInfo(info){
	const url = `${eventURL}/info`
	const request = postRequest(url,info)
	return {
		type: types.SAVE_EVENT_INFO,
		payload: request
	}
}
export function saveEventDetails(details) {
	const url = `${eventURL}/details`
	const request = postRequest(url,details)
	return {
		type: types.SAVE_EVENT_DETAILS,
		payload: request
	}
}
export function saveLaneConditionsInfo(conditions){
	const url = `${eventURL}/oilconditions`
	const request = postRequest(url,conditions)
	return {
		type: types.SAVE_LANE_INFO,
		payload: request
	}
}
export function saveEventSetup(setup){
	const url = `${eventURL}/setup`
	const request = postRequest(url,setup)
	return {
		type: types.SAVE_EVENT_SETUP,
		payload: request
	}
}
export function deleteEvent(event) {
	const url = `${eventURL}/${event.eventId}/delete`
	const request = postRequest(url,event)
	return {
		type: types.DELETE_EVENT,
		payload: request
	}
}
export function copyEvent(event) {
	const url = `${eventURL}/${event.eventId}/copy`
	const request = postRequest(url,event)
	return {
		type: types.COPY_EVENT,
		payload: request
	}
}
export function enableUpload(event){
	const url = `${eventURL}/${event.eventId}/enableupload`
	const request = postRequest(url,event)
	return {
		type: types.ENABLE_UPLOAD,
		payload: request
	}	
}
export function notifySchoolNotFound(school) {
    
	const url = `${eventURL}/${school.eventId}/schoolnotfound`
	const request = postRequest(url,school)
	console.log('notifySchoolNotFound action event')
	return {
		type: types.NOTIFY_SCHOOL_NOT_FOUND,
		payload:request
	}
}
export function resendEventEmail(event) {
	const url = `${eventURL}/${event.eventId}/resendemail`
	const request = postRequest(url,event)
	return {
		type: types.RESEND_DIRECTOR_EMAIL,
		payload: request
	}
}
export function resendingEventEmail() {	
	return {
		type: types.RESENDING_DIRECTOR_EMAIL
	}
}
export function setUserRole(isAdmin) {	
	return {
		type: types.SET_USER_ROLE,
		payload: isAdmin
	}
}
export function setWizardStep(step) {	
	return {
		type: types.SET_WIZARD_STEP,
		payload: step
	}
}
export function fetchCompletedEvents() 
{
		
	const url = `${eventURL}/pendinguploads`
	const request = getRequest(url)
	return {
		type: types.FETCH_COMPLETED_EVENTS,
		payload: request
	}
}
export function getParticipantRoster() {
    return {
         type: types.GETTING_PARTICIPANT_ROSTER
    }
 }
export function resetEventRetrieved(){
	return {
		type: types.RESET_RETRIEVED_EVENT
   }
}
export function setCertificationNumber(certificationNumber,forceCertificationNumber){
	return {
		type: types.SET_CERTIFICATION_NUMBER,
		payload: {
			certificationNumber,
			forceCertificationNumber
		}
   }
}
export function uploadEventResults(eventId,certificationNumber,resultsFile)
{
	const url = `${postEventURL}/${eventId}/${certificationNumber}/uploadresults`
	const request = axios.post(url,resultsFile,
		{ 
			crossdomain: true,
			headers: {
				'Access-Control-Allow-Origin' : '*',
				'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
				'content-type': 'multipart/form-data' 
			}
		}
	)
	return {
		type: types.fileUpload.UPLOAD_EVENT_RESULTS,
		payload: request
	}
}
export function setEventResultsFile(filename)
{
	return {
		type: types.fileUpload.SET_EVENT_RESULTS_FILENAME,
		payload: filename
   }
}
export function resetEventResultsFile()
{
	return {
		type: types.fileUpload.RESET_EVENT_RESULTS_FILE
   }
}
export function uploadingResultsFile()
{
	return {
		type: types.fileUpload.UPLOADING_RESULTS_FILE
   }
}
export function setWrongFileType()
{
	return {
		type: types.fileUpload.WRONG_FILE_UPLOAD_TYPE
   }
}
export function resetUploadErrorMessage()
{
	return {
		type: types.fileUpload.RESET_UPLOAD_ERROR_MESSAGE
   }
}



// WEBPACK FOOTER //
// ./src/redux/actions/action_event.js